import { render } from "./qrcommande.vue?vue&type=template&id=b99ae85c&scoped=true"
import script from "./qrcommande.vue?vue&type=script&lang=js"
export * from "./qrcommande.vue?vue&type=script&lang=js"

import "./qrcommande.vue?vue&type=style&index=0&id=b99ae85c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b99ae85c"]])

export default __exports__